import { Order, PartnerConfig } from '@/types';

import { matchCobrandedPartner } from '../configs/cobrandedPartners';

const getCobrandedConfig = (order?: Order): PartnerConfig | undefined =>
  matchCobrandedPartner(order);

export default getCobrandedConfig;
